@file:OptIn(InternalResourceApi::class)

package manyverse.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/manyverse.shared.generated.resources/"

@delegate:ResourceContentHash(974_358_502)
internal val Res.drawable.crochet_default: DrawableResource by lazy {
      DrawableResource("drawable:crochet_default", setOf(
        ResourceItem(setOf(), "${MD}drawable/crochet_default.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_018_425_422)
internal val Res.drawable.fig_mj: DrawableResource by lazy {
      DrawableResource("drawable:fig_mj", setOf(
        ResourceItem(setOf(), "${MD}drawable/fig_mj.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_167_718_818)
internal val Res.drawable.fig_player: DrawableResource by lazy {
      DrawableResource("drawable:fig_player", setOf(
        ResourceItem(setOf(), "${MD}drawable/fig_player.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_405_333_204)
internal val Res.drawable.fig_table: DrawableResource by lazy {
      DrawableResource("drawable:fig_table", setOf(
        ResourceItem(setOf(), "${MD}drawable/fig_table.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-836_796_744)
internal val Res.drawable.fig_universes: DrawableResource by lazy {
      DrawableResource("drawable:fig_universes", setOf(
        ResourceItem(setOf(), "${MD}drawable/fig_universes.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_235_896_623)
internal val Res.drawable.icon_apple: DrawableResource by lazy {
      DrawableResource("drawable:icon_apple", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_apple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_497_356_208)
internal val Res.drawable.icon_backpack_open: DrawableResource by lazy {
      DrawableResource("drawable:icon_backpack_open", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_backpack_open.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-878_110_679)
internal val Res.drawable.icon_bluesky: DrawableResource by lazy {
      DrawableResource("drawable:icon_bluesky", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_bluesky.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_448_665_670)
internal val Res.drawable.icon_bomb: DrawableResource by lazy {
      DrawableResource("drawable:icon_bomb", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_bomb.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_132_100_630)
internal val Res.drawable.icon_dice_1: DrawableResource by lazy {
      DrawableResource("drawable:icon_dice_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_dice_1.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(477_156_395)
internal val Res.drawable.icon_dice_6: DrawableResource by lazy {
      DrawableResource("drawable:icon_dice_6", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_dice_6.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-147_118_474)
internal val Res.drawable.icon_discord: DrawableResource by lazy {
      DrawableResource("drawable:icon_discord", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_discord.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_913_964_505)
internal val Res.drawable.icon_eraser: DrawableResource by lazy {
      DrawableResource("drawable:icon_eraser", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_eraser.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_832_062_828)
internal val Res.drawable.icon_google: DrawableResource by lazy {
      DrawableResource("drawable:icon_google", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_google.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(635_504_867)
internal val Res.drawable.icon_incognito: DrawableResource by lazy {
      DrawableResource("drawable:icon_incognito", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_incognito.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(64_983_732)
internal val Res.drawable.icon_instagram: DrawableResource by lazy {
      DrawableResource("drawable:icon_instagram", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_instagram.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_371_029_889)
internal val Res.drawable.icon_message_in: DrawableResource by lazy {
      DrawableResource("drawable:icon_message_in", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_message_in.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-335_673_107)
internal val Res.drawable.icon_message_out: DrawableResource by lazy {
      DrawableResource("drawable:icon_message_out", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_message_out.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_440_155_300)
internal val Res.drawable.icon_open_book: DrawableResource by lazy {
      DrawableResource("drawable:icon_open_book", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_open_book.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_044_908_162)
internal val Res.drawable.icon_open_page: DrawableResource by lazy {
      DrawableResource("drawable:icon_open_page", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_open_page.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(612_301_253)
internal val Res.drawable.icon_skull: DrawableResource by lazy {
      DrawableResource("drawable:icon_skull", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_skull.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_409_796_457)
internal val Res.drawable.icon_sword_cross: DrawableResource by lazy {
      DrawableResource("drawable:icon_sword_cross", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_sword-cross.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-373_477_539)
internal val Res.drawable.icon_treasure_chest: DrawableResource by lazy {
      DrawableResource("drawable:icon_treasure_chest", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_treasure-chest.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(155_909_782)
internal val Res.drawable.icon_wave_sound: DrawableResource by lazy {
      DrawableResource("drawable:icon_wave_sound", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_wave_sound.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_928_697_087)
internal val Res.drawable.icon_wizard: DrawableResource by lazy {
      DrawableResource("drawable:icon_wizard", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_wizard.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_444_064_859)
internal val Res.drawable.icon_youtube: DrawableResource by lazy {
      DrawableResource("drawable:icon_youtube", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_youtube.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_356_310_565)
internal val Res.drawable.lock_default: DrawableResource by lazy {
      DrawableResource("drawable:lock_default", setOf(
        ResourceItem(setOf(), "${MD}drawable/lock_default.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_005_479_583)
internal val Res.drawable.logo: DrawableResource by lazy {
      DrawableResource("drawable:logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("crochet_default", Res.drawable.crochet_default)
  map.put("fig_mj", Res.drawable.fig_mj)
  map.put("fig_player", Res.drawable.fig_player)
  map.put("fig_table", Res.drawable.fig_table)
  map.put("fig_universes", Res.drawable.fig_universes)
  map.put("icon_apple", Res.drawable.icon_apple)
  map.put("icon_backpack_open", Res.drawable.icon_backpack_open)
  map.put("icon_bluesky", Res.drawable.icon_bluesky)
  map.put("icon_bomb", Res.drawable.icon_bomb)
  map.put("icon_dice_1", Res.drawable.icon_dice_1)
  map.put("icon_dice_6", Res.drawable.icon_dice_6)
  map.put("icon_discord", Res.drawable.icon_discord)
  map.put("icon_eraser", Res.drawable.icon_eraser)
  map.put("icon_google", Res.drawable.icon_google)
  map.put("icon_incognito", Res.drawable.icon_incognito)
  map.put("icon_instagram", Res.drawable.icon_instagram)
  map.put("icon_message_in", Res.drawable.icon_message_in)
  map.put("icon_message_out", Res.drawable.icon_message_out)
  map.put("icon_open_book", Res.drawable.icon_open_book)
  map.put("icon_open_page", Res.drawable.icon_open_page)
  map.put("icon_skull", Res.drawable.icon_skull)
  map.put("icon_sword_cross", Res.drawable.icon_sword_cross)
  map.put("icon_treasure_chest", Res.drawable.icon_treasure_chest)
  map.put("icon_wave_sound", Res.drawable.icon_wave_sound)
  map.put("icon_wizard", Res.drawable.icon_wizard)
  map.put("icon_youtube", Res.drawable.icon_youtube)
  map.put("lock_default", Res.drawable.lock_default)
  map.put("logo", Res.drawable.logo)
}
